import { render, staticRenderFns } from "./ComPayDetail.vue?vue&type=template&id=7b1ea12a&scoped=true&"
import script from "./ComPayDetail.vue?vue&type=script&lang=js&"
export * from "./ComPayDetail.vue?vue&type=script&lang=js&"
import style0 from "./ComPayDetail.vue?vue&type=style&index=0&id=7b1ea12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ea12a",
  null
  
)

export default component.exports